import React from "react";

import { useToasts } from "react-toast-notifications";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { IconButton } from "@shared/buttons";

export const ShareButton = () => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const { addToast } = useToasts();

  return (
    <IconButton
      variant="secondary"
      leftIcon={<i className="fa-sharp fa-regular fa-link mr-1.5" />}
      className="font-bold"
      onClick={async () => {
        prettyLogEventPage({
          domain: "Share Button",
          action: "onClick",
        });

        try {
          await navigator.clipboard.writeText(window.location.href);
          addToast("Copied to clipboard!", { appearance: "success" });
        } catch (err) {
          addToast("Error while coping to clipboard!", {
            appearance: "error",
          });
        }
      }}
    >
      SHARE
    </IconButton>
  );
};
